import { render, staticRenderFns } from "./PDPObjectiveInformation.vue?vue&type=template&id=752f0f36&scoped=true&"
import script from "./PDPObjectiveInformation.vue?vue&type=script&lang=js&"
export * from "./PDPObjectiveInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752f0f36",
  null
  
)

export default component.exports